import { defineMessages } from 'react-intl';

export const productHintsItemMessages = defineMessages({
  cardHeader: {
    id: 'productHintsCard.header',
    defaultMessage: 'Hinweise',
  },
});
